// https://fordprofile.cms.dealer.com/connectivity.htm
export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'mustang-view-inventory'
					) ||
					eventData?.attributes?.class?.includes?.(
						'expedition-view-inventory'
					),
				payload: {
					payload: {
						onclick: {
							onclick: 'connectivity:content:search inventory',
							onclickLinkName: 'connectivity:content:action'
						}
					}
				}
			},
			{
				logic: ({ eventData }) =>
					eventData?.widgetClasses?.includes?.('faq-accordion') &&
					eventData?.attributes?.['aria-expanded'] === 'true',
				payload: ({ eventData }) => ({
					payload: {
						onclick: {
							onclick: `connectivity:content:accordion:${eventData.text}`,
							onclickLinkName: 'connectivity:content:action'
						}
					}
				})
			}
		]
	}
};
